/* import __COLOCATED_TEMPLATE__ from './project-digest-card.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-admin-project-digest-card';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  /** @param {Ember.Service|null} */
  moment: null,

  /** @param {ProjectDigest|null} */
  projectDigest: null,

  /** @param {boolean} */
  showFullDescription: false,

  /** @param {Function} */
  onAddToast: () => {},

  /** @param {Function} */
  onGetThumbnail: () => {},

  /** @param {Function} */
  onOpenVideoPlayer: () => {},

  /** @param {Function} */
  setClassificationsChanged: () => {},

  /** @param {Function} */
  setFeaturedChanged: () => {},

  classificationItems: {},

  /** @type {Boolean} */
  hasThumbnailLoaded: false,

  /** @type {Boolean} */
  hasThumbnailFailed: false,

  /** @type {Boolean} */
  hasVisibleThumbnail: computed(
    'projectDigest.thumbnailUrl',
    'hasThumbnailLoaded',
    'hasThumbnailFailed',
    function () {
      if (this.get('hasThumbnailFailed')) return false;

      return this.projectDigest.thumbnailUrl && this.hasThumbnailLoaded;
    },
  ),

  /** @type {String} */
  submittedAt: computed('projectDigest.createdAt', function () {
    const date = this.get('projectDigest.createdAt');
    return this.get('moment').moment(date).format('MM/DD/YYYY');
  }),

  /** @type {String} */
  completedAt: computed('projectDigest.application.completedAt', function () {
    const date = this.get('projectDigest.application.completedAt');
    return date
      ? this.get('moment').moment(date).format('MM/DD/YYYY')
      : '';
  }),

  /** @type {String} */
  videoCategoryString: computed('projectDigest.videoCategory.label', function () {
    return this.get('projectDigest.videoCategory.label') || 'No category';
  }),

  /** @type {String} */
  videoTopicsString: computed('projectDigest.videoTopics', function () {
    const videoTopics = this.get('projectDigest.videoTopics');
    return videoTopics.get('length')
      ? videoTopics.map((videoTopic) => videoTopic.get('label')).join(' • ')
      : 'No topics';
  }),

  /** @type {String} */
  locationString: computed(
    'projectDigest.wasDoneOnPlatform',
    'projectDigest.application.location.formattedAddress',
    function () {
      const projectDigest = this.get('projectDigest');
      return projectDigest.get('wasDoneOnPlatform')
        ? projectDigest.get('application.location.formattedAddress') || 'No location'
        : 'No location';
    },
  ),

  /** @type {String} */
  locationLink: computed(
    'projectDigest.wasDoneOnPlatform',
    'projectDigest.application.location.formattedAddress',
    function () {
      const projectDigest = this.get('projectDigest');
      const location = projectDigest.get('application.location');
      return projectDigest.get('wasDoneOnPlatform') && location
        ? location.get('getGoogleMapsLink')
        : '';
    },
  ),

  actions: {
    handleCopyLink() {
      navigator.clipboard.writeText(this.get('projectDigest.link'))
        .then(() => this.get('onAddToast')('Link copied to clipboard'))
        .catch(() => this.get('onAddToast')('Failed to copy link'));
    },

    handleThumbnailClick() {
      const projectDigest = this.get('projectDigest');

      this.get('onOpenVideoPlayer')(projectDigest);
    },

    handleThumbnailError() {
      this.set('hasThumbnailFailed', true);
    },

    handleThumbnailLoad() {
      this.set('hasThumbnailLoaded', true);
    },
  },
});
